import * as DialogPrimitive from '@radix-ui/react-dialog';


const DialogPortal = DialogPrimitive.Portal;

export { DialogPortal };
